var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <picture class=\"picture\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"bg") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":4,"column":32}}})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"modificator") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":5,"column":54}}})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"className") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":6,"column":41}}})) != null ? stack1 : "")
    + "\">\n        <source type=\"image/webp\"\n        "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,__default(require("../helpers/eq.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"lazy") : depth0),false,{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":9,"column":18},"end":{"line":9,"column":33}}}),{"name":"unless","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":9,"column":88}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,__default(require("../helpers/eq.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"lazy") : depth0),false,{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":10,"column":18},"end":{"line":10,"column":33}}}),{"name":"unless","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":10,"column":8},"end":{"line":10,"column":119}}})) != null ? stack1 : "")
    + ">\n        <img\n        "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,__default(require("../helpers/eq.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"lazy") : depth0),false,{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":13,"column":18},"end":{"line":13,"column":33}}}),{"name":"unless","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":13,"column":88}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,__default(require("../helpers/eq.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"lazy") : depth0),false,{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":14,"column":18},"end":{"line":14,"column":33}}}),{"name":"unless","hash":{},"fn":container.program(16, data, 0),"inverse":container.program(18, data, 0),"data":data,"loc":{"start":{"line":14,"column":8},"end":{"line":14,"column":109}}})) != null ? stack1 : "")
    + "\n        src=\""
    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + "\"\n        srcset=\""
    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"placeholder") : stack1), depth0))
    + "\"\n        class=\"picture__img\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"bg") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":18,"column":41}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"addclassName") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":8},"end":{"line":19,"column":51}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,__default(require("../helpers/eq.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"lazy") : depth0),false,{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":20,"column":18},"end":{"line":20,"column":33}}}),{"name":"unless","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":8},"end":{"line":22,"column":19}}})) != null ? stack1 : "")
    + "\"\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"alt") : depth0),{"name":"if","hash":{},"fn":container.program(29, data, 0),"inverse":container.program(31, data, 0),"data":data,"loc":{"start":{"line":23,"column":8},"end":{"line":23,"column":54}}})) != null ? stack1 : "")
    + ">\n    </picture>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "picture--bg";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "picture--"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"modificator") : depth0), depth0));
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"className") : depth0), depth0));
},"8":function(container,depth0,helpers,partials,data) {
    return "data-sizes=\"auto\"";
},"10":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "sizes=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"sizes") : depth0), depth0))
    + "\"";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-srcset=\""
    + container.escapeExpression(__default(require("../helpers/webp.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"srcSet") : stack1),{"name":"webp","hash":{},"data":data,"loc":{"start":{"line":10,"column":48},"end":{"line":10,"column":69}}}))
    + "\"";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "srcset=\""
    + container.escapeExpression(__default(require("../helpers/webp.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"srcSet") : stack1),{"name":"webp","hash":{},"data":data,"loc":{"start":{"line":10,"column":86},"end":{"line":10,"column":107}}}))
    + "\"";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-srcset=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"srcSet") : stack1), depth0))
    + "\"";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "srcset=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"srcSet") : stack1), depth0))
    + "\"";
},"20":function(container,depth0,helpers,partials,data) {
    return "picture__img--bg";
},"22":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"addclassName") : depth0), depth0));
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"carousel") : depth0),{"name":"if","hash":{},"fn":container.program(25, data, 0),"inverse":container.program(27, data, 0),"data":data,"loc":{"start":{"line":21,"column":12},"end":{"line":21,"column":62}}})) != null ? stack1 : "")
    + "\n        ";
},"25":function(container,depth0,helpers,partials,data) {
    return "swiper-lazy";
},"27":function(container,depth0,helpers,partials,data) {
    return "lazyload";
},"29":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " alt=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0))
    + "\"";
},"31":function(container,depth0,helpers,partials,data) {
    return "alt=\"\"";
},"33":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <picture class=\"picture\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"bg") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":4},"end":{"line":27,"column":32}}})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"modificator") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":4},"end":{"line":28,"column":54}}})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"className") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":4},"end":{"line":29,"column":41}}})) != null ? stack1 : "")
    + "\">\n        <img class=\"picture__img\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"bg") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":8},"end":{"line":31,"column":41}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,__default(require("../helpers/eq.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"lazy") : depth0),false,{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":32,"column":18},"end":{"line":32,"column":33}}}),{"name":"unless","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":8},"end":{"line":34,"column":19}}})) != null ? stack1 : "")
    + "\"\n        "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,__default(require("../helpers/eq.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"lazy") : depth0),false,{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":35,"column":18},"end":{"line":35,"column":33}}}),{"name":"unless","hash":{},"fn":container.program(34, data, 0),"inverse":container.program(36, data, 0),"data":data,"loc":{"start":{"line":35,"column":8},"end":{"line":35,"column":89}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"alt") : depth0),{"name":"if","hash":{},"fn":container.program(38, data, 0),"inverse":container.program(31, data, 0),"data":data,"loc":{"start":{"line":36,"column":8},"end":{"line":36,"column":53}}})) != null ? stack1 : "")
    + ">\n    </picture>\n";
},"34":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"image") : depth0), depth0))
    + "\"";
},"36":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"image") : depth0), depth0))
    + "\"";
},"38":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "alt=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0))
    + "\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,__default(require("../helpers/eq.js")).call(alias1,__default(require("../helpers/typeof.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"image") : depth0),{"name":"typeof","hash":{},"data":data,"loc":{"start":{"line":2,"column":10},"end":{"line":2,"column":24}}}),"object",{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":2,"column":6},"end":{"line":2,"column":34}}}),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(33, data, 0),"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":38,"column":7}}})) != null ? stack1 : "");
},"useData":true});